module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n<div class=\"spl-class-page page-content wh100\">\n    <div class=\"table w100\">\n        <div class=\"section\">\n            <div class=\"title\">Описание</div>\n            <div>\n                <div\n                    data-control-type=\"text-area\"\n                    data-control-target=\"item.description\"\n                >\n                    ")
    ; __append(escapeFn( item.description ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Поставщик</div>\n            <div>\n                ")
    ; __append(escapeFn( item.providername ))
    ; __append("\n            </div>\n        </div>\n    </div>\n    <div class=\"padding__tb-5 collapsing-section\" style=\"margin-top: 15px;\">\n        <div class=\"title\" style=\"margin-bottom: 10px;\">Стиль</div>\n        <div name=\"layer-composer\" class=\"layer-composer\"/>\n    </div>\n\n    ")
    ;  if (check("Spatial.ClassAttributes", Security.AccessMode.Insert)) { 
    ; __append("\n    <div class=\"padding__tb-5 collapsing-section collapsed\" style=\"margin-top: 15px;\">\n        <div class=\"title\" style=\"margin-bottom: 10px;\">Атрибуты</div>\n        <div name=\"attributes-grid\" class=\"attributes-grid\"></div>\n    </div>\n    ")
    ;  } 
    ; __append("\n    <!--<div data-control-type=\"label\" data-control-name=\"name\" data-control-title=\"title\" data-control-value=\"value\">html</div>-->\n</div>\n")
  }
  return __output.join("");

}